import React, { Component } from 'react';
import { FILTER } from './HistoryContainer.js';
import { translate } from 'react-i18next';

class HistorySearch extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="panel panel-default panel-search-history">
        <div className="panel-content">
          <div className="jumbotron panel-body-search-history">
            <form className="form-horizontal" method="post" onSubmit={this.props.handleSearchSubmit}>
              <fieldset>
                <div className="form-group " style={{ paddingInline: "10px" }}>
                  <select
                    className="form-control"
                    id="filter"
                    onChange={this.props.handleFilterChange}
                    value={this.props.filter}>
                    <option value={FILTER.ALL}>{t('dashboard.history.filter_all')}</option>
                    <option value={FILTER.USER}>{t('dashboard.history.filter_user')}</option>
                  </select>
                </div>
                <div className="form-group" style={{ paddingBottom: '0px', paddingInline: "10px" }}>
                  <button
                    className="btn btn-block btn-primary btn-search-history"
                    type="submit">
                    {t('dashboard.history.btn_apply')}
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(HistorySearch);



// WEBPACK FOOTER //
// ./src/dashboard/history/HistorySearch.js